import { FC } from "react";
import { Box, Heading, VStack, HStack, IconButton, Text, Grid, GridItem, Link } from "@chakra-ui/react";
import { FaSoundcloud, FaSpotify } from "react-icons/fa";

export const Music: FC = () => {
  return (
    <Box padding="4" maxWidth="1200px" margin="auto" bg="gray.800" color="white">
      <Heading as="h1" size="xl" textAlign="center" marginBottom="8">Cure for the soul</Heading>
      <Grid templateColumns="repeat(2, 1fr)" gap={6}>
        <GridItem>
          <Box padding="4" borderWidth="1px" borderRadius="lg" boxShadow="lg" bg="gray.800">
            <HStack spacing="4" alignItems="center" marginBottom="4">
              <IconButton
                icon={<FaSoundcloud />}
                aria-label="SoundCloud Icon"
                size="lg"
                colorScheme="orange"
                background="black"
              />
              <Heading as="h2" size="lg" color="white">My Music</Heading>
            </HStack>
            <iframe
              width="100%"
              height="300"
              scrolling="no"
              frameBorder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1243836427&color=%2300aabb&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            ></iframe>
          </Box>
        </GridItem>
        <GridItem>
          <Box padding="4" borderWidth="1px" borderRadius="lg" boxShadow="lg" bg="gray.800">
            <HStack spacing="4" alignItems="center" marginBottom="4">
              <IconButton
                icon={<FaSpotify />}
                aria-label="Spotify Icon"
                size="lg"
                colorScheme="green"
                background="black"
              />
              <Heading as="h2" size="lg" color="white">Spotify Playlist</Heading>
            </HStack>
            <iframe
              src="https://open.spotify.com/embed/playlist/37i9dQZF1E8Rioccf1BIKu?utm_source=generator" 
              width="100%"
              height="300"
              frameBorder="0"
              allow="encrypted-media"
            ></iframe>
          </Box>
        </GridItem>
      </Grid>
      <Box textAlign="center" marginTop="8">
        <Text fontSize="lg" marginBottom="4">Follow me on Spotify to see what I'm listening to:</Text>
        <Link href="https://open.spotify.com/user/224w72spg57kh3odctaydawsa" isExternal color="teal.500" fontSize="lg">
          My Spotify Profile
        </Link>
      </Box>
    </Box>
  );
};
